module.exports = __webpack_public_path__ + "static/media/dua-lipa.f7a28294.jpg";